__turbopack_context__.v({
  "checkIcon": "MxLepa_checkIcon",
  "confidenceIcon": "MxLepa_confidenceIcon",
  "container": "MxLepa_container",
  "content": "MxLepa_content",
  "dividerLine": "MxLepa_dividerLine",
  "fade-in-up": "MxLepa_fade-in-up",
  "featureIcon": "MxLepa_featureIcon",
  "featureItem": "MxLepa_featureItem",
  "featuresTitle": "MxLepa_featuresTitle",
  "highlightAi": "MxLepa_highlightAi",
  "imageContainer": "MxLepa_imageContainer",
  "imageContainerAnimated": "MxLepa_imageContainerAnimated",
  "mainHeading": "MxLepa_mainHeading",
  "productGroupsIcon": "MxLepa_productGroupsIcon",
  "segmentingIcon": "MxLepa_segmentingIcon",
  "slide-in-from-right": "MxLepa_slide-in-from-right",
  "subtitle": "MxLepa_subtitle",
  "typesIcon": "MxLepa_typesIcon",
});
